<template>
  <div>
    <div v-html="message"></div>
    <span>Nom de l'application: {{ __("SITE_TITLE") }}</span>
  </div>
</template>

<script>
module.exports = {
  name: "example-component",
  props: {
    username: {
      type: String,
      default: "Utilisateur",
    },
  },
  data: function () {
    return {
      message: "Bienvenue dans le tableau de bord, <b>" + this.username + "</b>!",
    };
  },
};
</script>

<style scoped lang="scss">
span {
  color: #555;
}
</style>